import { ServerOnly } from '@wkda/funnel-components';
import { Helmet } from 'react-helmet';

/**
 * This function returns a React component that uses the ServerOnly component to ensure
 * that the enclosed Helmet component and its script are only rendered on the server side.
 * The script sets up a MutationObserver to track when a specific form field becomes enabled
 * and dispatches a custom event 'manufacturerEnabled' with the time taken for this to occur.
 * It also pushes this time to the dataLayer for analytics purposes.
 *
 * @returns {JSX.Element} A React component that includes a Helmet component with a script.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function CarleadDataLayerManufacturerActive() {
  return /*#__PURE__*/_jsx(ServerOnly, {
    children: () => {
      return /*#__PURE__*/_jsx(Helmet, {
        children: /*#__PURE__*/_jsx("script", {
          id: "manufacturer-datalayer-timing",
          type: "text/javascript",
          children: manufacturerActiveScript
        })
      });
    }
  });
}
const manufacturerActiveScript = `
(function () {
  if (window.performance.timing.loadEventEnd === undefined || window.performance.timing.navigationStart === undefined) {
    return;
  }
  var manufacturerObserverActive = false
  var config = { attributes: false, childList: true, subtree: true };

  if (!manufacturerObserverActive) {
    var observer = new MutationObserver(callback);
    observer.observe(document, config);
    manufacturerObserverActive = true;
  }

  function callback(mutationsList, observer) {
    var trackedTimeMS = Date.now() - window.performance.timing.navigationStart;
    var firstSelect = document.querySelector('#field-manufacturer .carlead-creation-field__control');
    if (firstSelect === null) {
      return;
    }
    if (trackedTimeMS <= 0 || trackedTimeMS > 20000) {
      observer.disconnect();
      return;
    }
    if (!firstSelect.hasAttribute('disabled')) {
      document.dispatchEvent(new Event('manufacturerEnabled'));
      window.manufacturerEnabledTime = trackedTimeMS;
      dataLayer.push({
        "event": "step1.manufacturer.enabled.time",
        "manufacturerEnabledTime": trackedTimeMS
      });
      observer.disconnect();
    }
  }
})();`;